import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntAntrieb: SelectDataObject[] = [
    { i: 0, t: '(unbekannt)' },
    { i: 1, t: 'Frontantrieb' },
    { i: 2, t: 'Heckantrieb' },
    { i: 3, t: 'Allradantrieb' },
    { i: 4, t: 'Kette' },
    { i: 5, t: 'Kardan' },
    { i: 6, t: 'Riemen' },
    { i: 31, t: 'Allradantrieb zuschaltbar' },
    { i: 32, t: 'Allradantrieb permanent' },
];
export default sIntAntrieb;
